<template>
  <Flex class="flexColumn">
    <Flex class="bottomMarginHalf fontSizeHalf flexColumn" v-for="metric in screenSet.metrics" :key="metric.details.id">
      <Flex>
        <div class="grayText bold">
          {{metric.details.name}}
        </div>
        <Flex class="mainAxisFlexEnd base1Text heavy">Reset</Flex>
      </Flex>
      <Flex>
        <Flex v-for="i in [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]" :key="i" class="width25Px height25Px centerCenter whiteText"
          :style="{backgroundColor: colorScale()(i), color: textColorScale()(i)}"
        >
          {{i}}
        </Flex>
      </Flex>
      <Flex>
        <b-slider
          v-bind:min="0"
          v-bind:max="10"
          v-model="filters.columns[`composite_values_${values.id}`]"
          v-on:change="maybeGetResults"
        />
      </Flex>
    </Flex>
  </Flex>
</template>

<script>
import chroma from 'chroma-js';
import Flex from '@frontend/components/Flex.vue';

export default {
  data() {
    return {
    };
  },
  components: { Flex },
  props: {
    screenSet: Array,
  },
  methods: {
    colorScale() {
      return chroma.scale(['#49040F', '#DE2131', '#C83A1E', '#DE7021', '#F4DEB8', '#F5EABA', '#E4E9C6', '#C4E37D', '#A7D572', '#8AC468', '#3FA25C']).domain([0, 10]);
    },
    textColorScale() {
      return chroma.scale(['#DD3C57', '#FFFFFF', '#FBD7D0', '#F6DBD5', '#C2861E', '#C8A91E', '#868E57', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']).domain([0, 10]);
    }
  },
  created() {
    console.log('SCREEN', this.screenSet)
    console.log([...Array(10).keys()].reverse())
  }
};
</script>
